import { configureStore } from "@reduxjs/toolkit";
import ccOnboardingReducer from "./ccOnboardingSlice";
import labOnboardingReducer from "./labOnboardingSlice";

export const store = configureStore({
  reducer: {
    ccOnboarding: ccOnboardingReducer,
    labOnboarding: labOnboardingReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
